<template>
  <div>
    <div
      class="bg-FFFFFF fb fb-cross-center lh-48 pl-16 pr-12"
      :class="{ 'fb-main-center': hasArrow }"
    >
      <span
        v-show="hasArrow"
        class="iconfont c-c7c7cc font-24 mr-16"
        @click="handlerPrevNextWeek(1)"
        >&#xe68a;</span
      >
      <span
        @click="handlerChooseWeek"
        class="font-28 c-171A1D"
        v-if="weekList && weekList.length && weekList[weekNow]"
        >{{ weekList[weekNow].teachWeekDesc }} ({{
          weekList[weekNow].startDay
        }}
        ~ {{ weekList[weekNow].endDay }})</span
      ><span
        v-show="hasArrow"
        class="iconfont c-c7c7cc font-24 ml-16"
        @click="handlerPrevNextWeek(2)"
        >&#xe68d;</span
      ><i
        @click="handlerChooseWeek"
        v-show="!hasArrow"
        class="iconfont c-171A1D font-24 pl-4"
        >&#xe681;</i
      ></div
    >
    <common-action-sheet
      :list="ationList"
      :open="showActionSheet"
      @cancel="handlerToClose"
      @choose="chooseWeek"
    >
    </common-action-sheet>
  </div>
</template>

<script>
import mixin from '@/mixin'
import commonActionSheet from './commonActionSheet'
import { dateToTime, timeFormat } from '@/utils/comUtils'
import API from '@/api'
export default {
  mixins: [mixin],

  components: { commonActionSheet },
  props: {
    hasArrow: {
      type: Boolean,
      default: true
    },
    innerCampusId: {
      type: String,
      default: ''
    },
    startDay: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      weekList: this.$store.getters.weekList || [],
      weekNow: this.$store.getters.weekNow,
      showActionSheet: false,
      ationList: []
    }
  },
  computed: {
    startDimDay() {
      return (this.weekList[this.weekNow] || {}).teachWeekStartDimDay
    },
    endDimDay() {
      return (this.weekList[this.weekNow] || {}).teachWeekEndDimDay
    }
  },
  watch: {
    weekNow: {
      handler(v) {
        if (+v >= 0 && this.startDimDay && this.endDimDay) {
          this.$emit('getWeek', v, this.startDimDay, this.endDimDay)
        }
      },
      immediate: false
    }
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {
    this.fetchWeekList()
  },
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    // 选择周
    handlerChooseWeek() {
      this.ationList =
        (this.weekList &&
          this.weekList.length &&
          this.weekList.map(item => {
            return {
              id: item.teachWeekId,
              name: `${item.teachWeekDesc} (${item.startDay} ~ ${item.endDay})`
            }
          })) ||
        []

      this.showActionSheet = true
    },
    chooseWeek(detail, index) {
      this.weekNow = index
      this.$store.commit('weekNow', this.weekNow)
      this.showActionSheet = false
    },
    handlerToClose(show) {
      this.showActionSheet = show
    },
    // 上周/下周 1: 上周 2: 下周
    handlerPrevNextWeek(tag) {
      if (
        (tag === 1 && this.weekNow <= 0) ||
        (tag === 2 && this.weekNow >= this.weekList.length - 1)
      ) {
        return false
      }
      if (tag === 1) {
        this.weekNow--
      } else {
        this.weekNow++
      }
      this.$store.commit('weekNow', this.weekNow)
    },
    handlerWeekList(res, forceUpdate) {
      let _now = forceUpdate
        ? timeFormat(new Date(), 'YYYYMMDD')
        : this.startDay || timeFormat(new Date(), 'YYYYMMDD')
      let list = []
      let dateNow = ''
      const { termStartDimDay, termEndDimDay, termOrder, firstEnd } =
        this.$store.getters.semesterSetting
      let currentDateTerm = termOrder
      currentDateTerm = _now <= firstEnd ? 1 : 2 // 当前日期的学期
      let currentWeek = []
      res.map(v => {
        if (v.schoolTermOrder === currentDateTerm) {
          currentWeek = v.schoolTermTeachWeekRespList || []
        }
      })
      // 学期之间
      if (_now >= termStartDimDay && _now <= termEndDimDay) {
        dateNow = timeFormat(new Date(), 'YYYY.MM.DD')
        let flag = false
        currentWeek.map(item => {
          if (
            (+this.weekNow === -1 || forceUpdate) &&
            +_now >= +item.teachWeekStartDimDay &&
            +_now <= +item.teachWeekEndDimDay
          ) {
            this.weekNow = +item.teachWeekId - 1
            flag = true
            list.push(item)
          }
          if (!flag) {
            list.push(item)
          }
        })
      } else if (_now < termStartDimDay) {
        list.push(currentWeek && currentWeek[0])
        this.weekNow = currentWeek.length && +currentWeek[0].teachWeekId - 1
        dateNow = dateToTime(termStartDimDay, '.')
      } else if (_now > termEndDimDay) {
        list = currentWeek
        this.weekNow = list.length && +list[list.length - 1].teachWeekId - 1
        dateNow = dateToTime(termEndDimDay, '.')
      }
      // 获取月份 根据学期的开始结束时间计算月份区间
      this.weekList = list.reduce((list, item, termIndex) => {
        return list.concat({
          schoolTermOrder: item.schoolTermOrder,
          startDay: dateToTime(`${item.teachWeekStartDimDay}`, '.'),
          endDay: dateToTime(`${item.teachWeekEndDimDay}`, '.'),
          teachWeekDesc: item.teachWeekDesc,
          teachWeekStartDimDay: item.teachWeekStartDimDay,
          teachWeekEndDimDay: item.teachWeekEndDimDay,
          teachWeekId: item.teachWeekId,
          teachWeekOrder: item.teachWeekId
        })
      }, [])
      this.$store.commit('dateNow', dateNow)
      this.$store.commit('weekNow', this.weekNow)
      this.$store.commit('weekList', this.weekList)
      this.$emit('getWeek', this.weekNow, this.startDimDay, this.endDimDay)
    },
    fetchWeekList(forceUpdate = false) {
      if (this.weekList && this.weekList.length && !forceUpdate) {
        this.$emit('getWeek', this.weekNow, this.startDimDay, this.endDimDay)
      } else {
        return new Promise((resolve, reject) => {
          API.getYearTeachWeek({
            operUserRoleTypes: `${this.currentRole}`,
            campusId: this.curIsGuardian
              ? this.innerCampusId || this.campusId
              : this.campusId,
            schoolYear: this.$store.getters.semesterSetting.schoolYear
          })
            .then(res => {
              if (res && res.result && res.result !== '0') {
                resolve([])
              } else {
                res = res || []
                this.handlerWeekList(res, forceUpdate)
                resolve(res)
              }
            })
            .catch(err => {
              reject(err)
            })
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
